import React, { useRef, useState, useEffect } from "react";
import { saveBlob, getBlob } from "../../utils/idbBlobStorage";
import { useDispatch } from "react-redux";
import { setCompanyField } from "../../redux/actions/subscriptionActions";

export default function VideoUploader({
  maxDuration = 300,
  onVideoSelected,
  label = "Sélectionner une vidéo",
}) {
  const fileInputRef = useRef(null);
  const [videoUrl, setVideoUrl] = useState(null);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      try {
        const savedBlob = await getBlob("maVideo");
        if (savedBlob) {
          const url = URL.createObjectURL(savedBlob);
          setVideoUrl(url);
        }
      } catch (err) {
        console.error("Erreur récupération blob sauvegardé:", err);
      }
    })();
  }, []);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (e) => {
    setError(null);
    const file = e.target.files[0];
    if (!file) return;

    const url = URL.createObjectURL(file);
    const video = document.createElement("video");
    video.preload = "metadata";

    video.onloadedmetadata = async () => {
      URL.revokeObjectURL(url);
      if (video.duration > maxDuration) {
        setError(`La vidéo ne doit pas dépasser ${maxDuration / 60} minutes.`);
        return;
      }

      try {
        await saveBlob("maVideo", file);
        dispatch(setCompanyField("presentationVideoBase64", "maVideo"));
        const savedUrl = URL.createObjectURL(file);
        setVideoUrl(savedUrl);
      } catch (err) {
        console.error("Erreur sauvegarde blob :", err);
        setError("Erreur lors de la sauvegarde de la vidéo.");
        return;
      }

      if (typeof onVideoSelected === "function") {
        const reader = new FileReader();
        reader.onload = () => {
          onVideoSelected({ file, base64: reader.result });
        };
        reader.readAsDataURL(file);
      }
    };

    video.onerror = () => {
      setError("Le fichier sélectionné n'est pas une vidéo valide.");
    };

    video.src = url;
    e.target.value = null;
  };

  return (
    <div style={styles.container}>
      <button type="button" onClick={handleButtonClick}>
        {label}
      </button>

      <input
        type="file"
        accept="video/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {error && <p style={styles.error}>{error}</p>}

      {videoUrl && (
        <video src={videoUrl} controls style={styles.video} />
      )}
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    alignItems: "flex-start",
    margin: "auto",
    width:"fit-content",
  },
  video: {
    width: "300px",
    maxHeight: "200px",
    borderRadius: "4px",
    margin: "auto",

  },
  error: {
    color: "red",
    fontSize: "0.9rem",
    margin: "auto",

  },
};
